import { render, staticRenderFns } from "./l-add-group-popup.vue?vue&type=template&id=41321a14&scoped=true"
import script from "./l-add-group-popup.vue?vue&type=script&lang=js"
export * from "./l-add-group-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41321a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41321a14')) {
      api.createRecord('41321a14', component.options)
    } else {
      api.reload('41321a14', component.options)
    }
    module.hot.accept("./l-add-group-popup.vue?vue&type=template&id=41321a14&scoped=true", function () {
      api.rerender('41321a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mlocalization/views/popups/l-add-group-popup.vue"
export default component.exports